import React, { useEffect, useState, useRef } from 'react';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import { useForm } from "react-hook-form";
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import HttpHelper from '../../service/httpService'
import { CiEdit } from "react-icons/ci";
import { AiOutlineDelete } from "react-icons/ai";
import Loader from '../../Components/Loader';
import Accordion from 'react-bootstrap/Accordion';
import DashboardWrapper from './DashboardWrapper';
import { RxCross1, RxCross2 } from 'react-icons/rx';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";
import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";


const SecurityObjectName = 'Website.Locations';

const DashboardLocations = (props) => {

    const {
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Indent,
        Outdent,
        OrderedList,
        UnorderedList,
        Undo,
        Redo,
        FontSize,FontName,
        FormatBlock,
        Link,
        Unlink,
        ViewHtml,
        InsertTable,
        AddRowBefore,
        AddRowAfter,
        AddColumnBefore,
        AddColumnAfter,
        DeleteRow,
        DeleteColumn,
        DeleteTable,
        MergeCells,
        SplitCell,
    } = EditorTools;

    const editor = useRef();
    const [contentData, setContentData] = useState("");
  


    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const formRef = useRef();
    const [locations, setLocations] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const [locationId, setLocationId] = useState(0);
    const [isEditing, setIsEditing] = useState(false);
    const [bannerImage, setBannerImage] = useState(null);
    const [imageCurrentShow, setImageCurrentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);
    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');

    const [locationIdUpdate, setLocationIdUpdate] = useState('');
    const [rowVersion, setRowVersion] = useState('');
    const [fileId, setFileId] = useState('');
    const [fileDetails, setFileDetails] = useState('');
    const [primaryKeyEncrypted, setPrimaryKeyEncrypted] = useState('');

    const [originalLocationImage, setOriginalLocationImage] = useState(null);
    const onSubmit = async (data, event) => {
        setLoaderApi(true);
        if (isEditing === true) {
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("Location/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        locationUpdate(data, locationId, data.FileId)
                        delete data.file;
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            } else {
                locationUpdate(data, locationId)
            }
        }
        else {
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("Location/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        data.locationId = 0;
                        locationAdd(data)
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            } else {
                locationAdd(data)
            }
        }
    };

    const locationAdd = async (data) => {
        //delete data.locationId
        await HttpHelper.post("Location", data).then((response) => {
            props.showToast('success', 'Location Added Succesfully');
            setLoaderApi(false);
            setPopupAddEdit(false);
            GetLocationList();
        }).catch((error) => {
            setLoaderApi(false);
            setPopupAddEdit(false);
            console.log(error);
        })
    }

    const locationUpdate = async (data, id, imageId) => {
        if (imageId === undefined) {
            Object.assign(data,
                { rowVersion: rowVersion },
                { LocationId: locationIdUpdate },
                { FileId: fileId }
            );
            delete data.file;
        } else {
            Object.assign(data,
                { rowVersion: rowVersion },
                { FactId: locationIdUpdate },
                { FileId: imageId }
            );
            delete data.file;
        }
        console.log(data)

        await HttpHelper.put("Location", data).then((response) => {
            props.showToast('success', 'Location Added Succesfully');
            setLoaderApi(false);
            setPopupAddEdit(false);
            GetLocationList();
            blankFormData()
        }).catch((error) => {
            console.log(error);
            setLoaderApi(false);
        })
    }

    const deleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("Location/DeleteFileAsync?fileId=" + fileId).then((res) => {
            if (res.status === 200) {
                console.log('file deleted successfully', fileId);
            } else {
                console.log(res.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    const GetLocationList = async () => {
        setLoaderApi(true);
        await HttpHelper.get("Location").then((response) => {
            if (response.status == 200) {
                setLocations(response.data.data);
                getAllPermission();
                setIsEditing(true);
                setLoaderApi(false);
            } else {
                console.info(response.data.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }
    const getLocationById = async (locationid) => {

        setPopupAddEdit(true);
        setLoaderApi(true);

        setIsEditing(true);
        setShowLoader(true);

        setValue('Heading', '');
        setValue('SubHeading', '');
        setValue('Content', '');
        setBannerImage('');
        setValue("locationId", '');
        setOriginalLocationImage('');
        setLocationId('');
        setPrimaryKeyEncrypted('');
        setBannerImage('');

        await HttpHelper.get("Location/" + locationid).then((response) => {
            if (response.status === 200) {
                setLocationIdUpdate(response.data.locationId);
                setRowVersion(response.data.rowVersion)
                setFileId(response.data.fileId);
                if (response.data.file) {
                    setFileDetails(response.data.file);
                }

                console.log(response.data);
                setContentData(response.data.content);
                setValue('Heading', response.data.heading);
                setValue('SubHeading', response.data.subHeading);
                setValue('Content', response.data.content);
                if (response.data.file) {
                    setBannerImage(response.data.file.fileUrl);
                } else {
                    setBannerImage(null);
                }
                setValue("locationId", response.data.locationId);
                setOriginalLocationImage(response.data.image);
                setLocationId(response.data.locationId);
                setPrimaryKeyEncrypted(response.data.primaryKeyEncrypted);
                accordianStatusHandle('1')
            }
            setShowLoader(false);
            setPopupAddEdit(true);
            setLoaderApi(false);
        }).catch((error) => {
            setShowLoader(false)
            console.log(error);
        })
    }
    const deleteLocation = async (locationId, fileId) => {
        swal("Are you sure, you want to delete this location?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    await HttpHelper.delete("Location/" + locationId).then((response) => {
                        if (response.status === 200) {
                            GetLocationList();
                        }
                        if (fileId) {
                            deleteUploadedFile(fileId)
                        }
                        props.showToast('success', 'Location Deleted successfully');
                    }).catch((error) => {
                        console.log(error);
                    })
                }
            });
    }

    const blankFormData = () => {
        setIsEditing(false)
        setValue('file', '');
        setValue('Heading', '');
        setValue('SubHeading', '');
        setValue('Content', '');
        const view = editor.current.view;
        if (view) {
            EditorUtils.setHtml(view, '');
        }
    }

    const accordianStatusHandle = (elem) => {

        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }

    useEffect(() => {
        GetLocationList();
    }, []);
    return (
        <DashboardWrapper>
            <ToastContainer />
            <div className="DashboardWrapperChild">
                <Sidebar />
                <div className="contentWrapper">
                    <HeaderDashboard title="Locations" />
                    <div className="container-fluid mt-80 p-0">
                        <div className="row">
                            {hasAddPermissionUser == true ? <div className="col-auto">
                                {isEditing === true ? <button onClick={() => {
                                    setPopupAddEdit(true);
                                    blankFormData();
                                    accordianStatusHandle('1');
                                }} className="btn btnSave">Add Location</button> : ''}
                            </div> : ''}
                            <div className="col-md-12 mb-2">
                            </div>


                            {hasAddPermissionUser == true && loaderApi == false ?
                                <div className="col-md-12 mb-2 table-responsive">
                                    <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                        <table className="table tableCustomized table-striped">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        #
                                                    </th>
                                                    <th>
                                                        Heading
                                                    </th>
                                                    <th>
                                                        SubHeading
                                                    </th>
                                                    <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                        Image
                                                    </th>
                                                    <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    locations.length > 0 ? locations.map((location, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{location.heading}</td>
                                                                <td>{location.subHeading}</td>
                                                                <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                                    {
                                                                        location.file && location.file.fileUrl ? < img src={location.file.fileUrl} width="30" height="30" /> : null
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {hasEditPermissionUser == true ? <CiEdit onClick={() => { getLocationById(location.locationId) }} /> : ''}
                                                                    {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => {
                                                                        if (location.fileId !== 'undefined' || location.fileId !== null) {
                                                                            deleteLocation(location.locationId, location.fileId)
                                                                        } else {
                                                                            deleteLocation(location.locationId)
                                                                        }
                                                                    }} /> : ''}
                                                                </td>
                                                            </tr>)
                                                    })
                                                        : <tr><td colSpan="5">No data found!!!</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(1 1)" stroke-width="2">
                                                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                </div>}

                            <Accordion className="d-none" defaultActiveKey="0" activeKey={accordianStatus} ref={AccordianHandle}>
                                {hasReadPermissionUser == true ? <Accordion.Item eventKey="0" onClick={() => {
                                    accordianStatusHandle();
                                }}>
                                    <Accordion.Header>Location Grid</Accordion.Header>
                                    <Accordion.Body onClick={(e) => {
                                        e.stopPropagation();
                                    }}>
                                        <div className="col-md-12 mb-2">
                                            <div className="cardBox cardTableWrapperDashboard">
                                                <div className="row">
                                                    <table className="table tableCustomized table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    #
                                                                </th>
                                                                <th>
                                                                    Heading
                                                                </th>
                                                                <th>
                                                                    SubHeading
                                                                </th>
                                                                <th>
                                                                    Image
                                                                </th>
                                                                <th>
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                locations.length > 0 ? locations.map((location, index) => {
                                                                    return (<tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{location.heading}</td>
                                                                        <td>{location.subHeading}</td>
                                                                        <td>
                                                                            {location.file && location.file.fileUrl !== null ?
                                                                                <>
                                                                                    <b className="imageViewButton" onClick={() => {
                                                                                        setShowImgPopup(true);
                                                                                        setImageCurrentShow(location.file.fileUrl);
                                                                                    }}>View Image</b>
                                                                                </>
                                                                                : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-image-fill" viewBox="0 0 16 16">
                                                                                    <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                                                                                    <path d="M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z" />
                                                                                </svg>}
                                                                        </td>
                                                                        <td>
                                                                            {hasEditPermissionUser == true ? <CiEdit onClick={() => { getLocationById(location.locationId) }} /> : ''}
                                                                            {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => {
                                                                                if (location.fileId !== 'undefined' || location.fileId !== null) {
                                                                                    deleteLocation(location.locationId, location.fileId)
                                                                                } else {
                                                                                    deleteLocation(location.locationId)
                                                                                }
                                                                            }} /> : ''}
                                                                        </td>
                                                                    </tr>)
                                                                })
                                                                    : <tr><td colSpan="5">No data found!!!</td></tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item> : ''}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                <div className="crossPopup" onClick={() => {
                    setShowImgPopup(false);
                    setImageCurrentShow('');
                }}>
                    <RxCross1 />
                </div>
                <img src={imageCurrentShow} />
            </div>
            {hasAddPermissionUser || hasEditPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                <div className="popupEditAndAddForm">
                    <div className="popupEditAndAddFormCloseButton" onClick={() => {
                        setPopupAddEdit(false);
                        setIsEditing(true);
                    }} >
                        <RxCross2 />
                    </div>

                    {loaderApi == true ? <div className="loaderApi">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                            <g fill="none" fill-rule="evenodd">
                                <g transform="translate(1 1)" stroke-width="2">
                                    <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                    <path d="M36 18c0-9.94-8.06-18-18-18">
                                        <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                    </path>
                                </g>
                            </g>
                        </svg>
                    </div>
                        :
                        <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                            <div className="cardBox">
                                <h4>{isEditing === true ? "Update Location" : "Create Location"}</h4>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Heading</label>
                                        <input type="text"  {...register("Heading")} className="border mb-2" placeholder="Heading" />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Sub Heading :</label>
                                        <input type="text"  {...register("SubHeading")} className="border mb-2" placeholder="Heading" />
                                    </div>
                                    <div className="col-md-12">
                                        <label>File : {isEditing === true ? <span class="requiredAstric"> *</span> : ''}</label>
                                        <br />
                                        <label>{fileDetails != null ? fileDetails.originalFileName : ''} </label>
                                        <input type="file"  {...register('file', { required: isEditing === true ? false : true })} className="border mb-2 w-100" is-invalid />
                                        {errors.file?.type === 'required' && <p className="text-danger" role="alert">File is required</p>}
                                    </div>
                                    <div className="col-md-12">
                                        <label>Content :</label>
                                        <Editor className="border" placeholder="Content"
                                            tools={[
                                                [Bold, Italic, Underline, Strikethrough],
                                                [Subscript, Superscript],
                                                [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                                [Indent, Outdent],
                                                [OrderedList, UnorderedList],
                                                FontSize,FontName,
                                                FormatBlock,
                                                [Undo, Redo],
                                                [Link, Unlink, ViewHtml],
                                                [InsertTable],
                                                [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                                                [DeleteRow, DeleteColumn, DeleteTable],
                                                [MergeCells, SplitCell],
                                            ]}
                                            ref={editor}
                                            defaultContent={contentData}
                                            onChange={(e) => {
                                                const regex = /(<([^>]+)>)/gi;
                                                const result = e.html.replace(regex, "");
                                                if (result.length > 0)
                                                    setValue('Content', e.html);
                                                else
                                                    setValue('Content', null);

                                            }}
                                        />
                                        <textarea className="border d-none" {...register("Content", { required: true })} placeholder="Content"></textarea>
                                        {errors.Content?.type === 'required' && <p className="text-danger" role="alert"> Content is required</p>}
                                    </div>
                                    {
                                        isEditing === true ?
                                            <input type="hidden" {...register('locationId')} />
                                            : null
                                    }
                                    <div className="col-md-12 d-flex justify-content-end mt-6">
                                        <div>
                                            <button className="btn btnSave mt-2" >Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>}

                </div>
            </div> : ''}
        </DashboardWrapper>
    )
}

export default DashboardLocations;